
var api = {
    urlAPI: "https://app-service-iron-group.com.ar/api/api/",
    urlImagenes: "https://app-service-iron-group.com.ar/api/Imagenes/",
    crmOportunidades: "https://app-service-iron-group.com.ar/api/api/crm/oportunidades",
    crmTurnos: "https://app-service-iron-group.com.ar/api/api/crm/turnos",
    crmMaquinas:"https://app-service-iron-group.com.ar/api/api/crm/maquinas",
    crmClientes:"https://app-service-iron-group.com.ar/api/api/crm/clientes/",
    ordenes:"https://app-service-iron-group.com.ar/api/api/ordenes/",
    ordenesHoras:"https://app-service-iron-group.com.ar/api/api/horas/",
    reporteServicio:"https://app-service-iron-group.com.ar/api/api/reporte/servicio/"


}

export default api